import { ShiftInterface } from "@type/workMonitor.types"
import { createContext } from "react"

export interface ShiftEventsContextProps {
	shift: ShiftInterface | null
	fetchShiftByScheduleId: (scheduleId: string) => void
	loadingShiftActivity: boolean
}

const ShiftEventsRetainContext = createContext<ShiftEventsContextProps>({
	shift: null,
	fetchShiftByScheduleId: () => undefined,
	loadingShiftActivity: false,
})

export default ShiftEventsRetainContext
